<div class="coming-soon flex h-[80vh] flex-col items-center justify-center gap-4 text-center">
  <div class="icon mb-4 h-[48px] w-[48px]">
    <!-- you can replace with any SVG or icon component -->
    <svg class="h-full w-full" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 14h-2v-2h2v2zm0-4h-2V6h2v6z" />
    </svg>
  </div>
  <h1 class="mb-2 text-4xl">
    {{ isArabic() ? "قريباً" : "Coming Soon" }}
  </h1>
  <p class="text-2xl opacity-80">
    {{ isArabic() ? "نعمل حالياً على إطلاق شيء مميز." : "We’re working hard to launch something amazing." }}
  </p>
</div>
